var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-placeholder hero is-medium is-light is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Hi Member!!!")]),_c('h2',{staticClass:"subtitle"},[_vm._v("Welcome to landing international")])])])])
}]

export { render, staticRenderFns }